<!--
 * @Author: wangzhu10 wangzhu10@jd.com
 * @Date: 2022-08-25 11:16:07
 * @LastEditors: wangzhu10 wangzhu10@jd.com
 * @LastEditTime: 2022-09-03 16:59:45
-->
<template>
  <div class="sign-wrapper">
    <div v-title data-title="签到赚积分"></div>
    <div class="sign-top">
      <div class="sign-top-item">
        <div class="sign-top-label">连续签到天数</div>
        <div class="sign-top-value">{{userInfo.continuouslyCheckInDays}}</div>
      </div>
      <div class="sign-top-item">
        <div class="sign-top-label">当前积分</div>
        <div class="sign-top-value">{{userInfo.points}}</div>
      </div>
    </div>
    <van-calendar
      :min-date="minDate"
      :max-date="maxDate"
      color="#4290f7"
      :show-title="false"
      :poppable="false"
      :show-confirm="false"
      :readonly="true"
    >
      <template slot="bottom-info" slot-scope="day">
        <van-icon
          v-if="signRecord[day.text - 1]"
          name="success"
          :color="day.text === signRecord.length ? '#fff' : '#67C23A'" />
      </template>
    </van-calendar>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import api from '../../api'

const day = new Date()

export default {
  data() {
    return {
      minDate: new Date(day.getFullYear(), day.getMonth(), 1),
      maxDate: new Date(day.getFullYear(), day.getMonth(), day.getDate()),
      signRecord: []
    }
  },
  computed: {
    ...mapState(['userInfo']),
  },
  created() {
    this.getSignHistory()
    this.handleBack()
  },
  methods: {
    handleBack() {
      const _this = this
      let options = {
          disabled: true,
          callback: function() {
            _this.$router.go(-1)
          }
      }
      window.jme.browser.setGoBackDisabled(options)
    },
    getSignHistory() {
      const day = new Date()
      const year = day.getFullYear()
      const month = day.getMonth() + 1
      const date = day.getDate()
      const params = {
        st: `${year}-${month < 10 ? 0 : ''}${month}-01`,
        et: `${year}-${month < 10 ? 0 : ''}${month}-${date < 10 ? 0 : ''}${date}`
      }
      api.signHistory(params).then(res => {
        const { code, data } = res
        if (code === 200) {
          this.signRecord = Object.values(data)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.sign-wrapper {
  font-size: 14px;
  background: #4290f7;
  .sign-top {
    display: flex;
    color: #fff;
    padding: 30px 0;
  }
  .sign-top-item {
    flex: 1;
    line-height: 1;
    .sign-top-label {
      font-size: 12px;
      margin-bottom: 10px;
    }
    .sign-top-value {
      font-size: 30px;
      font-weight: 700;
    }
  }
  /deep/ .van-calendar__header-subtitle {
    text-align: left;
    padding-left: 10px;
  }
  /deep/ .van-calendar__selected-day {
    border-radius: 50%;
  }
}
</style>
